import { render, staticRenderFns } from "./AfterSubmitDialog.vue?vue&type=template&id=0b7b8f9a&"
import script from "./AfterSubmitDialog.vue?vue&type=script&lang=js&"
export * from "./AfterSubmitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports